import get from "lodash/get";

// person_type + consentMethodType
const consentTypeMapping = {
    'PatientElectronic':'consent_patient_form',
    'PatientEmail':'consent_patient_form',
    'PatientPaper':'consent_patient_form',
    'PatientRegainedCapacity':'consent_patient_regained_capacity_form',
    'PatientEmailRegainedCapacity':'consent_patient_regained_capacity_form',
    'PatientRegainedCapacityPaper':'consent_patient_regained_capacity_form',
    'PatientAfterDeferralElectronic':'participant_after_deferral',
    'PatientAfterDeferralEmail':'participant_after_deferral',
    'PatientAfterDeferralPaper':'participant_after_deferral',
    'PatientRegainedCapacityAfterDeferralElectronic':'patient_regained_capacity_after_deferral',
    'PatientRegainedCapacityAfterDeferralEmail':'patient_regained_capacity_after_deferral',
    'PatientRegainedCapacityAfterDeferralPaper':'patient_regained_capacity_after_deferral',

    'SurrogateElectronic':'consent_surrogate',
    'SurrogateEmail':'consent_surrogate',
    'SurrogatePaper':'consent_surrogate',
    'SurrogateAfterDeferralElectronic':'surrogate_after_deferral',
    'SurrogateAfterDeferralEmail':'surrogate_after_deferral',
    'SurrogateAfterDeferralPaper':'surrogate_after_deferral',

    'EmergencyElectronic':'consent_emergency',
    'EmergencyEmail':'consent_emergency',
    'EmergencyPaper':'consent_emergency',
  };
export const getBackendConsentType = (personType, consentMethodType) => {
  if (!personType || !consentMethodType){
    return null;
  }
  // this is probably temporary
  let consentType = get(consentTypeMapping, personType + consentMethodType);

  console.log("getBackendConsentType", personType + consentMethodType, consentType);
  return consentType;

};


// WEBPACK FOOTER //
// ./src/utils/consentUtils.js